document.querySelectorAll('.readmore').forEach(function (btn) {
  btn.addEventListener('click', function (event) {
    event.preventDefault();

    var descriptionFull = document.querySelector('.product-description-full');
    var descriptionLongFull = document.querySelector('.product-long-description-full');
    descriptionLongFull.style.display = 'block';
    if (descriptionFull) {
      descriptionFull.style.display = 'block';
    }
    var descriptionShort = document.querySelector('.product-description-short');
    var descriptionLongShort = document.querySelector('.product-long-description-short');
    descriptionLongShort.style.display = 'none';
    if (descriptionShort) {
      descriptionShort.style.display = 'none';
    }
  });
});
document.querySelectorAll('.readless').forEach(function (btn) {
  btn.addEventListener('click', function (event) {
  event.preventDefault();
  
  var descriptionFull = document.querySelector('.product-description-full');
  var descriptionLongFull = document.querySelector('.product-long-description-full');
  if (descriptionFull) {
  descriptionFull.style.display = 'none';
    }
  descriptionLongFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  var descriptionLongShort = document.querySelector('.product-long-description-short');
  if (descriptionShort) {
  descriptionShort.style.display = 'block';
    // window.scrollTo({top: 110, behavior: 'smooth'});
    }
  descriptionLongShort.style.display = 'block';
  })
});
